var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-outfit-block"},[_c('div',{on:{"click":_vm.openInfoModal}},[_c('OutfitBlock',{attrs:{"outfit":_vm.outfit}})],1),_c('transition',{attrs:{"name":"fade"}},[(_vm.isInfoModalShow)?_c('ViewOutfit',{attrs:{"id":_vm.outfit.serial},on:{"back":_vm.closeInfoModal}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }